import { render } from "./Reward.vue?vue&type=template&id=34977118&scoped=true"
import script from "./Reward.vue?vue&type=script&lang=js"
export * from "./Reward.vue?vue&type=script&lang=js"

import "./Reward.vue?vue&type=style&index=0&id=34977118&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34977118"]])

export default __exports__